var map = {
	"./andreh-carapiet.png": [
		5596,
		596
	],
	"./anna-arakelyan.png": [
		6201,
		201
	],
	"./arazin-minasian.png": [
		6334,
		334
	],
	"./devinder-gandhi.png": [
		7181,
		181
	],
	"./garen-derhartunian.png": [
		6027,
		27
	],
	"./hayk-papukhyan.png": [
		1503,
		503
	],
	"./leah-ghadimi.png": [
		7302,
		302
	],
	"./lina-acopians.png": [
		1881,
		881
	],
	"./liya-zadoryan.png": [
		1470,
		470
	],
	"./manvel-kondradzhyan.png": [
		267,
		267
	],
	"./marina-tovmasian.png": [
		2419,
		419
	],
	"./narbeh-tovmassian.png": [
		9464,
		464
	],
	"./narineh-yermian.png": [
		8257,
		257
	],
	"./taleen-akopian.png": [
		6675,
		675
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8949;
module.exports = webpackAsyncContext;